const regexFindNumbers = /\d+/g;
const countUpDuration = 1000;

const animateValue = (
  $elementContainingNumber: HTMLElement,
  start: number,
  end: number,
  duration: number
) => {
  let startTimestamp: number | null = null;

  const step = (timestamp: number) => {
    if (!startTimestamp) {
      startTimestamp = timestamp;
    }

    const progress = Math.min((timestamp - startTimestamp) / duration, 1);

    $elementContainingNumber.innerHTML = Math.floor(
      progress * (end - start) + start
    ).toString();

    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };

  window.requestAnimationFrame(step);
};

const numericAnimation = () => {
  const SELECTOR = ".js-numeric-animation";

  if (typeof IntersectionObserver === "undefined") {
    return;
  }

  const checkEntry = (entry: IntersectionObserverEntry) => {
    const $entry = entry.target as HTMLHtmlElement;

    if (!entry.isIntersecting || !$entry.dataset.nums) {
      return;
    }

    const nums = JSON.parse($entry.dataset.nums.toString());

    for (let i = 0; i < nums.length; i++) {
      const $wrapper = $entry.querySelector(
        `.js-num-wrapper-${i}`
      ) as HTMLElement;

      animateValue($wrapper, 0, nums[i], countUpDuration);
    }

    // Remove width when animation complete
    setTimeout(() => {
      $entry.style.removeProperty("width");
    }, countUpDuration);

    observer.unobserve($entry);
    return;
  };

  const callback = (entries: IntersectionObserverEntry[]) => {
    entries.forEach(checkEntry);
  };

  const observer = new IntersectionObserver(callback, {
    rootMargin: "0px",
    threshold: 0,
  });

  document.querySelectorAll(SELECTOR).forEach(($el: Element) => {
    const $htmlEl = $el as HTMLElement;

    // Zero any numbers and add them to a data attribute so they can be counted up later
    const elementText = $el.innerHTML as string;
    let matchExecArray: RegExpExecArray | null;
    const matches: string[] = [];
    let count = 0;

    while (true) {
      matchExecArray = regexFindNumbers.exec(elementText);
      if (!matchExecArray) {
        break;
      }

      matches.push(matchExecArray[0]);

      // Set width so number changing doesn't result in things moving around
      $htmlEl.style.width = `${$el.clientWidth}px`;

      $el.innerHTML = $el.innerHTML.replace(
        matchExecArray[0],
        `<span class="js-num-wrapper-${count}">0</span>`
      );
      count++;
    }

    $el.setAttribute("data-nums", JSON.stringify(matches));

    // Observe to figure out when to count them back up
    observer.observe($el as HTMLElement);
  });
};

export default numericAnimation;
